import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion';
import { FormTextInput } from '@tanium/react-form-text-input';
import { Spinner } from '@tanium/react-spinner';
import { Stack } from '@tanium/react-stack';
import { css } from '@tanium/style-system';
import { TooltippedButton } from '@tanium/react-button';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const LoginFormTextInput = styled(FormTextInput)(
  css({
    width: '100%',
  })
);

interface LoginFormButtonProps {
  loading?: boolean;
  isDisabled?: boolean;
  tooltipContent?: string;
}
export const LoginFormButton: React.FC<LoginFormButtonProps> = ({ children, loading, isDisabled, tooltipContent }) => {
  return (
    <Box width="100%">
      <TooltippedButton
        style={{ width: '100%' }}
        type="submit"
        disabled={loading || isDisabled}
        tooltipContent={tooltipContent}
      >
        <Box as={Stack} justifyContent="center">
          {loading && (
            <Box mr={1}>
              <Spinner size={16} fill={false} />
            </Box>
          )}
          {children}
        </Box>
      </TooltippedButton>
    </Box>
  );
};
